import { Spinner } from '@/shared/components/spinner';
import { Loader } from '@/shared/components/ui/loader';

export function AppSplash() {
  return (
    <div className="grid min-h-dvh place-items-center">
      <div className="flex items-center gap-3">
        <span className="font-medium">
          <Loader />
        </span>
      </div>
    </div>
  );
}
